import gazetteer, { defaultLocale } from '@bridebook/toolbox/src/gazetteer';
import {
  BCP47LanguageTags,
  RoutingLocales as Locales,
  countryCodeToRoutingLocale as countryCodeToLocale,
  routingLocaleToCountryCode as localeToCountryCode,
  routingLocaleToLanguageTag,
} from '@bridebook/toolbox/src/i18n/constants';

export const alwaysLoadedNS = [
  'auth',
  'common',
  'countries',
  'datepicker',
  'enquiries',
  'mobileApp',
  'searchBar',
  'settings',
  'shortlistCategories',
  'shortlistModals',
  'supplierCategories',
  'ui',
  'venueConfirmation',
  'lostLead',
  'venuerex',
  'filters',
  'navigation',
  'quiz',
  'localeChange',
  'supplierCard',
  'toolWidgets',
  'weddingWebsite',
  'featuresTour',
];
const languageTags = gazetteer
  .getMarkets()
  .map((market) => ({
    locale: market.locale,
    folder: market.flags.translated ? market.locale : defaultLocale,
  }))
  .reduce<Record<string, string>>((acc, { locale, folder }) => {
    acc[locale] = folder;
    return acc;
  }, {});

export {
  BCP47LanguageTags,
  countryCodeToLocale,
  Locales,
  languageTags,
  localeToCountryCode,
  routingLocaleToLanguageTag,
};
